module.exports = __webpack_public_path__ + "img/remove.7c187f28.svg";